import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Box,
  Container,
  Grid,
} from '@mui/material';
import { colors } from '../utils/colors';
import languageConfig from '../config/languages';

function VideoSection() {
  const { t, i18n } = useTranslation();

  const videos = {
    en: [
      {
        id: '1101193392',
        title: 'File Upload Feature',
        description: 'Learn how to upload and analyze documents with Ulpian'
      }
    ],
    hr: [
      {
        id: '1101193882',
        title: 'Značajka prijenosa datoteka',
        description: 'Naučite kako prenijeti i analizirati dokumente s Ulpianom'
      },
      {
        id: '1090497091',
        title: 'Pretraživanje sudske prakse',
        description: 'Kako pretražiti sudsku praksu pomoću Ulpiana'
      }
    ]
  };

  if (!languageConfig.isLanguageEnabled(i18n.language)) {
    return null;
  }

  const currentVideos = videos[i18n.language];

  return (
    <Box
      id="video"
      sx={{
        py: 8,
        backgroundColor: colors.offWhite,
        textAlign: 'center',
        transition: 'all 0.3s ease',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            mb: 2,
            color: colors.darkRed,
            fontFamily: 'Exo, sans-serif',
            fontWeight: 'bold',
          }}
        >
          {t('video.title').split('Ulpian').map((part, index, array) => (
            <React.Fragment key={index}>
              {part}
              {index < array.length - 1 && (
                <span style={{ fontFamily: 'TanAshford, serif' }}>Ulpian</span>
              )}
            </React.Fragment>
          ))}
        </Typography>
        <Typography variant="body1" sx={{ mb: 6, color: colors.darkRed }}>
          {t('video.subtitle')}
        </Typography>
        <Grid container spacing={4}>
          {currentVideos.map((video, index) => (
            <Grid item xs={12} md={currentVideos.length === 1 ? 12 : 6} key={index}>
              <Typography variant="h5" sx={{ mb: 2, color: colors.darkRed }}>
                {video.title}
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, color: colors.darkRed }}>
                {video.description}
              </Typography>
              <Box
                sx={{
                  position: 'relative',
                  paddingBottom: '56.25%',
                  height: 0,
                  overflow: 'hidden',
                  borderRadius: '8px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                }}
              >
                <iframe
                  src={`https://player.vimeo.com/video/${video.id}?h=0&badge=0&autopause=0&player_id=0&app_id=58479`}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                  title={video.title}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default VideoSection;
